module.exports = __webpack_public_path__ + "static/media/RFP_Notification.cf6147d7.png";